import { UnassignedMerchantsPageContent } from "Components/Admin/UnassignedMerchants/UnassignedMerchantsPageContent";
import { AuthenticatedLayout } from "Components/Layout/AuthenticatedLayout";
import { StyledPageWrapper } from "Components/Shared/StyledComponents";
import { Resources, useResource } from "Translations/Resources";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Pages.Titles;

export const UnassignedMerchantsPage = () => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      title={t(RESOURCES.UnassignedMerchants)}
      backNavigation={{
        mode: "historyStack",
        fallbackUrl: appUrl("dashboard"),
      }}
    >
      <StyledPageWrapper maxWidth="unset !important">
        <UnassignedMerchantsPageContent />
      </StyledPageWrapper>
    </AuthenticatedLayout>
  );
};

export default UnassignedMerchantsPage;
